import React from "react";

function DropdownArrowIcon() {

  return (
    <svg xmlns="http://www.w3.org/2000/svg"viewBox="0 -960 960 960">
      <path d="M480-344 240-584l43-43 197 197 197-197 43 43-240 240Z"/>
    </svg>
  )

}

export default React.memo(DropdownArrowIcon);